import * as React from "react";
const SvgIcCopy = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M4 16V4H16V1H1V16H4ZM9 9H20V20H9V9ZM23 23V6H6V23H23Z" fill="currentColor" /></svg>;
export default SvgIcCopy;